export const ADICIONA_PROJETO = "ADICIONA_PROJETO";
export const ALTERA_PROJETO = "ALTERA_PROJETO";
export const EXCLUIR_PROJETO = "EXCLUIR_PROJETO";
